
export const acceptedfiletypes_dictionary = {
    //zip might be appllicable to everything but will need to fact check
    "bmp":["jpg","pdf","png","pnm","svg","tiff","webp","zip"],
    "csv":["pdf","xlsx","zip"],
    "djvu":["jpg","pdf","tiff","webp","zip"],
    "doc":["docx","html","jpg","png","txt","webp","xml","pdf"], //might be wrong as the serach was mainly docx, but in desc stated doc
    "docx":["html","jpg","odt","png","rtf","txt","webp","xml","pdf","tiff"],
    "dot":["pdf"],// other onces are unsure but would be jpg
    "dotx":["jpg","pdf","xml"],
    "dwf":["jpg","pdf","png","svg","tiff","webp"],
    "dwfx":["jpg","pdf","png","svg","tiff","webp"],
    "dwg":["jpg","pdf","png","svg","tiff","webp"],
    "dxf":["jpg","pdf","png","svg","tiff","webp"],
    "eml":["jpg","pdf","png","tiff","webp"],
    "eps":["jpg","pdf","png","tiff"],
    "epub":["jpg","pdf","png","tiff","webp"],
    "gif":["gif","jpg","pdf","png","pnm","svg","tiff","webp"],
    "heic":["jpg","jxl","pdf","png","pnm","svg","tiff","webp"],
    "heif":["jpg","pdf"],
    "htm":["docx","jpg","md","odt","pdf","png","txt","xls","xlsx"],
    "html":["xls","xlsx","pdf","md"],
    "ico":["jpg","pdf","png","svg","webp"],
    //widad starts here
    "jfif":["pdf"],
    "jpg":["gif","jxl","pdf","png","pnm","svg","tiff","webp"],
    "jpeg":["jpg","jxl","pdf","svg","tiff","webp"],
    "key":["pptx","pdf"],
    "log":["docx","pdf","txt"],
    "md":["html","pdf"],
    "mobi":["jpg","pdf","png","tiff","webp"],
    "msg":["jpg","pdf","png","tiff","webp"],
    "numbers":["csv","xlsx","pdf"],
    "odc":["jpg","pdf","png","tiff","webp"],
    "odf":["jpg","pdf","png","tiff","webp"],
    "odg":["pdf"],
    "odp":["jpg","pdf","png","tiff","webp"],
    "ods":["jpg","pdf","png","tiff","webp"],
    "odt":["docx","jpg","pdf","png","tiff","txt","webp","xml"],
    "pages":["docx","txt","pdf"],
    "png":["gif","jpg","pdf","pnm","svg","tiff","webp"],
    "potx":["jpg","pdf","png","pptx","tiff","webp"],
    "pps":["jpg","pdf","png","tiff","webp"],
    "ppsx":["jpg","pdf","png","pptx","tiff","webp"],
    //manjari starts here
    "ppt":["pptx","jpg","pdf","png","tiff","webp"],
    "pptx":["jpg","pdf","png","tiff","webp"],
    "prn":["jpg","pdf","png","tiff"],
    "ps":["jpg","pdf","png","tiff"],
    "psd":["jpg","png","pnm","svg","tiff","webp"],
    "pub":["jpg","pdf","png","tiff"],
    "rtf":["html","jpg","pdf","txt"],
    "svg":["jpg","pdf","png","pnm","tiff","webp"],
    //tif and tiff is the same.
    "tif":["jpg","pdf","png","pnm","svg","tiff","webp"],
    "tiff":["jpg","pdf","png","pnm","svg","tiff","webp"],
    "txt":["jpg","pdf"],
    //vsd and vsdx are somewhat the same
    "vsd":["jpg","pdf","png","tiff"],
    "vsdx":["jpg","pdf","png","tiff"],
    "webp":["gif","jpg","pdf","png","pnm","svg","tiff"],
    "wpd":["pdf"],
    "xls":["xlsx","csv","jpg","pdf","png","tiff","webp"],
    "xlsb":["csv","pdf"],
    "xlsx":["csv","jpg","pdf","png","tiff","webp"],
    "xltx":["pdf"]
};